import { apiClient, type ApiRequestConfig } from './api';
import type {
  TenantStripeCheckoutSessionRequest,
  TenantStripeCheckoutSessionResponse,
  TenantStripeConnectOnboardingLinkRequest,
  TenantStripeConnectOnboardingLinkResponse,
  TenantStripeConnectStatus,
} from '../types';

export async function getTenantStripeConnectStatus(): Promise<TenantStripeConnectStatus> {
  const response = await apiClient.get<TenantStripeConnectStatus>('/api/v1/web/tenant-payments/stripe/status');
  return response.data;
}

export async function createTenantStripeOnboardingLink(
  payload: TenantStripeConnectOnboardingLinkRequest
): Promise<TenantStripeConnectOnboardingLinkResponse> {
  const response = await apiClient.post<TenantStripeConnectOnboardingLinkResponse>(
    '/api/v1/web/tenant-payments/stripe/onboarding-link',
    payload
  );
  return response.data;
}

export async function createTenantFamilyRegistrationCheckout(
  registrationId: number,
  payload: TenantStripeCheckoutSessionRequest,
  config?: ApiRequestConfig
): Promise<TenantStripeCheckoutSessionResponse> {
  const response = await apiClient.post<TenantStripeCheckoutSessionResponse>(
    `/api/v1/web/tenant-family/registrations/${registrationId}/checkout`,
    payload, config
  );
  return response.data;
}

export async function createProviderRegistrationCheckout(
  providerId: number,
  registrationId: number,
  payload: TenantStripeCheckoutSessionRequest
): Promise<TenantStripeCheckoutSessionResponse> {
  const response = await apiClient.post<TenantStripeCheckoutSessionResponse>(
    `/api/v1/web/providers/${providerId}/registrations/${registrationId}/checkout`,
    payload
  );
  return response.data;
}
